var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"has-text-weight-bold has-text-info",on:{"click":function($event){$event.preventDefault();return _vm.downloadAs.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.getLabel)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }